import { useDocumentTitle } from '@pidelo/web-core';
import { EmptyState, PageHeader, Tabs } from '@pidelo/web-ui';
import { useSearchParams } from 'react-router';
import { menuLabel, type AdminSection } from '../app/sections.ts';
import { NoAccess } from '../components/SectionGate.tsx';
import { useAdminAccess } from '../layout/use-admin-access.ts';

/** A section whose API is not connected yet: its title, what it is for and an empty state. */
export function SectionPage({ section }: { section: AdminSection }) {
  const access = useAdminAccess();
  const [params, setParams] = useSearchParams();
  useDocumentTitle(`${menuLabel(section)} · Pídelo Admin`);
  const Icon = section.icon;

  if (!section.allowed(access)) return <NoAccess title={section.title} />;

  const tab = section.tabs?.find(item => item.value === params.get('view')) ?? section.tabs?.[0];
  const empty = tab?.empty ?? section.empty;
  const body = <EmptyState icon={<Icon />} title={empty.title}>{empty.text}</EmptyState>;

  return (
    <>
      <PageHeader title={section.title} />
      {section.tabs && tab ? (
        <Tabs
          label={section.title}
          items={section.tabs.map(item => ({ value: item.value, label: item.label }))}
          value={tab.value}
          onChange={value => setParams(value === section.tabs![0]!.value ? {} : { view: value }, { replace: true })}
        >
          {body}
        </Tabs>
      ) : (
        body
      )}
    </>
  );
}
